import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StatsPort } from './stats.port';
import {
  StatGenerali,
  AndamentoMensile,
  AndamentiQueryParams,
  StatsPie,
  StatsFlussoMensile
} from '../../models/stats.model';
import { PaginatedResponse } from '../../models/cantieri.model';
import { environment } from '../../../environments/environment';
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class StatsHttpService implements StatsPort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/stats`;

  getStats(year: number): Observable<StatGenerali> {
    const params = new HttpParams().set('year', year.toString());
    return this.http.get<StatGenerali>(this.base, { params });
  }

  getYears(): Observable<number[]> {
    return this.http.get<number[]>(`${this.base}/years`);
  }

  getAndamentiMensili(queryParams?: AndamentiQueryParams): Observable<PaginatedResponse<AndamentoMensile>> {
    let params = new HttpParams();

    if (queryParams) {
      if (queryParams.page != null) params = params.set('page', queryParams.page.toString());
      if (queryParams.size != null) params = params.set('size', queryParams.size.toString());

      if (Array.isArray(queryParams.sort) && queryParams.sort.length) {
        queryParams.sort.forEach((s) => {
          const v = (s ?? '').trim();
          if (!v) return;
          params = params.append('sort', v);
        });
      }
    }

    return this.http.get<PaginatedResponse<AndamentoMensile>>(`${this.base}/andamentiMensili`, { params });
  }

  getPie(anno: number) {
    return this.http.get<StatsPie>(`${this.base}/pie`, {
      params: { anno },
    });
  }

  getFlussoMensile(anno: number) {
    return this.http.get<StatsFlussoMensile[]>(`${this.base}/flussoMensile`, {
      params: { anno },
    });
  }
}
